export const NotYet = ({ text, center }) => {
    return (
        <div className={`not-yet-box ${center ? 'center' : ''}`}>
            <p> {text ? text : 'N/A'}</p>
        </div>
    );
};
